module.exports = __webpack_public_path__ + "static/media/24.27b3092a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/24.png
// module id = 984
// module chunks = 0